import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';



function Header(props) {
    const navigate = useNavigate();

    const [showHeader, setShowHeader] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [menuOpen, setMenuOpen] = useState(false);
    // const token = localStorage.getItem("token");

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > lastScrollY && currentScrollY > 50) {
                setShowHeader(false);
            } else {
                setShowHeader(true);
            }
            setLastScrollY(currentScrollY);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollY]);

    const toggleMenu = () => setMenuOpen(!menuOpen);

    const handleClick = (path, eventName) => {
        const isFbqAvailable = typeof window.fbq !== "undefined";

        if (isFbqAvailable) {
            if (eventName === "Planos") {
                window.fbq("trackCustom", "ClickPlanos", {
                    numberOfClicks: 1,
                });
            } else {
                const text = `PageView${eventName}`;

                window.fbq("trackCustom", text, {
                    numberOfClicks: 1,
                });

                console.log(`Rastreando evento customizado: ${text}`);
            }
        }

        navigate(path);

    };

    const handleDuvidas = () => {
        const isFbqAvailable = typeof window.fbq !== "undefined";

        if (isFbqAvailable) {
            window.fbq("trackCustom", "ClickBotaoWhatsApp", {
                numberOfClicks: 1,
            });
        }

        window.open(gerarLinkWhatsApp("Olá, tenho uma dúvida sobre os planos!"), "_blank");
    };

    return (
        <div
            style={{
                width: "100%",
                backgroundColor: showHeader ? "#233344" : "transparent",
                height: "80px",
                display: "flex",
                justifyContent: "center",
                position: "fixed",
                top: showHeader ? "0" : "10px",
                transition: "top 0.3s ease-in-out",
                zIndex: 1000,
            }}
        >
            <div
                className="header-container"
                style={{
                    backgroundColor: showHeader ? "transparent" : "#233344",
                    borderRadius: showHeader ? "0" : "40px",
                    marginTop: showHeader ? "0" : "10px",
                    paddingLeft: "40px",
                    paddingRight: "40px",
                    width: "60%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    color: "#fff",
                }}
            >
                {/* Logo */}
                <div
                    style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        cursor: "pointer",
                        color: "white"
                    }}
                    onClick={() => navigate("../")}
                >
                    <img src="/assets/Logo_Contblack_FundoEscuro.png" alt="Contblack Logo" style={{ height: "40px", marginTop: "5px" }} />
                </div>

                {/* Menu mobile toggle */}
                <div
                    onClick={toggleMenu}
                    style={{
                        display: "none",
                        cursor: "pointer",
                        flexDirection: "column",
                        gap: "4px",
                    }}
                    className="menu-toggle"
                >
                    <span style={{ width: "25px", height: "3px", backgroundColor: "#1EFF86" }}></span>
                    <span style={{ width: "25px", height: "3px", backgroundColor: "#1EFF86" }}></span>
                    <span style={{ width: "25px", height: "3px", backgroundColor: "#1EFF86" }}></span>
                </div>

                {/* Menu */}
                <div
                    style={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                    }}
                    className={`menu-items ${menuOpen ? "open" : "closed"}`}
                >
                    <p className="menu-button" onClick={() => handleClick("../sobreNos", "SobreNos")}
                        style={{ color: "#fff" }}>SOBRE NÓS</p>
                    <p className="menu-button" onClick={() => handleClick("../planos", "Planos")}
                        style={{ color: "#fff" }}>PLANOS</p>
                    <p className="menu-button" onClick={() => handleClick("../solucoes", "Solucoes")}
                        style={{ color: "#fff" }}>SOLUÇÕES</p>
                    <p className="menu-button" onClick={() => handleClick("../nichos", "Nichos")}
                        style={{ color: "#fff" }}>NICHOS</p>


                    {/* <p className="menu-button" onClick={handleDuvidas} style={{ color: "#fff" }}>DÚVIDAS</p> */}
                    <p className="menu-button" onClick={() => handleClick("../Blog", "blog")}
                        style={{ color: "#fff" }}>BLOG</p>
                    {/* <p className="menu-button" onClick={() => navigate("../sobreNos")}
                        style={{ color:"#fff" }}>BLOG</p> */}
                    <p
                        className="menu-button"
                        onClick={() => handleClick("../regularize", "RegularizeJa")}
                    >
                        REGULARIZE JÁ
                    </p>
                    <PersonOutlineIcon className="menu-button" style={{ color: "#1EFF86", fontSize: "20px" }} onClick={() => navigate("../Login")} />

                </div>
            </div>

            {/* CSS inline para hover e responsivo */}
            <style>
                {`
                .menu-button {
                    cursor: pointer;
                    transition: all 0.3s ease;
                    font-size: 12px;
                }
                .menu-button:hover {
                    color: #1EFF86 !important;
                    text-decoration: underline;
                    transform: scale(1.05);
                }
                .regularize-btn {
                    background-color: #1EFF86;
                    color: #233344 !important;
                    padding: 8px 16px;
                    border-radius: 20px;
                    font-weight: bold;
                    text-decoration: none !important;
                }
                .regularize-btn:hover {
                    background-color: #00d96e;
                    color: #233344 !important;
                    text-decoration: none !important;
                    transform: scale(1.05);
                }

                @media (max-width: 768px) {
                    .header-container {
                    width: 90% !important;
                    }
                    .menu-toggle {
                    display: flex !important;
                    }
                    .menu-items {
                    flex-direction: column;
                    position: absolute;
                    top: 60px;
                    left: 0;
                    width: 100%;
                    background-color: #233344;
                    padding: 10px 0;
                    }
                    .menu-items.closed {
                    display: none !important;
                    }
                    .menu-items.open {
                    display: flex !important;
                    }
                    .menu-items p {
                    padding: 10px;
                    text-align: center;
                    }
                }
                `}
            </style>
        </div>
    );
}

export default Header;
